// =============================================================================
// actions/incidentActions.js
// =============================================================================
import {
	INCIDENTS_FETCH_REQUEST, INCIDENTS_FETCH_SUCCESS, INCIDENTS_FETCH_FAILURE,
	INCIDENT_HISTORY_FETCH_REQUEST, INCIDENT_HISTORY_FETCH_SUCCESS, INCIDENT_HISTORY_FETCH_FAILURE,
	INCIDENT_SELECT, INCIDENT_FILTER_CHANGE, INCIDENT_FILTER_RESET,
} from '../constants/kpiConstants';

import { apiFetchIncidents, apiFetchIncidentHistory } from '../requests/kpiRequests';

// --- Lista de incidentes (sempre todos, sem filtros do backend) -------------
export function fetchIncidents() {
	return async function (dispatch) {
		dispatch({ type: INCIDENTS_FETCH_REQUEST });
		try {
			const res = await apiFetchIncidents();
			dispatch({ type: INCIDENTS_FETCH_SUCCESS, payload: res.data });
		} catch (err) {
			const msg = (err.response && err.response.data && err.response.data.error) || err.message;
			dispatch({ type: INCIDENTS_FETCH_FAILURE, payload: msg });
		}
	};
}

// --- Historico de um incidente ---------------------------------------------
export function fetchIncidentHistory(incidentId) {
	return async function (dispatch) {
		dispatch({ type: INCIDENT_HISTORY_FETCH_REQUEST });
		try {
			const res = await apiFetchIncidentHistory(incidentId);
			dispatch({ type: INCIDENT_HISTORY_FETCH_SUCCESS, payload: res.data });
		} catch (err) {
			const msg = (err.response && err.response.data && err.response.data.error) || err.message;
			dispatch({ type: INCIDENT_HISTORY_FETCH_FAILURE, payload: msg });
		}
	};
}

// --- Selecao e filtros ------------------------------------------------------
export function selectIncident(incident) {
	return { type: INCIDENT_SELECT, payload: incident };
}

export function changeFilter(filter) {
	return { type: INCIDENT_FILTER_CHANGE, payload: filter };
}

export function resetFilters() {
	return { type: INCIDENT_FILTER_RESET };
}
